// extracted by css-extract-rspack-plugin
export default {"spinner":"NewMarkdownViewer-module__spinner__L5zC6","safe-html-box":"NewMarkdownViewer-module__safe-html-box__ZT1eD"};